<template>
  <div>
    <component
      :is="component"
    />
  </div>
</template>
<script>
import Func0Noticias from '@/views/0/Func0Noticias.vue'

export default {
  name: 'Func0',
  data () {
    return {
      component: Func0Noticias
    }
  }
}
</script>
